import {AbstractControl, ValidatorFn} from "@angular/forms";

export class CustomValidators {


  /**
   * Validator function that ensures a date input is on or after the specified minimum date.
   *
   * @param {string} minDateString - The minimum date in a string format to validate against.
   * @return {ValidatorFn} A function that performs validation and returns an error object if the date is invalid or null if valid.
   */
  public static minDate(minDateString: string): ValidatorFn {
    const minDate = new Date(minDateString);

    return (control: AbstractControl) => {
      const value = control.value;
      // If the control has no value, skip validation (considered valid)
      if (!value) {
        return null;
      }

      const inputDate = new Date(value);

      if (isNaN(inputDate.getTime())) {
        return {invalidDate: true};
      }

      return inputDate >= minDate ? null : {minDate: {requiredDate: minDateString}};
    };
  }

  /**
   * Validator that checks if a given control's date value is less than or equal to a specified maximum date.
   *
   * @param {string} maxDateString - The maximum permissible date as a string in a valid date format.
   * @return {ValidatorFn} A function that takes an AbstractControl and returns a validation error object or null.
   */
  public static maxDate(maxDateString: string): ValidatorFn {
    const maxDate = new Date(maxDateString);

    return (control: AbstractControl) => {
      const value = control.value;
      // If the control has no value, skip validation (considered valid)
      if (!value) {
        return null;
      }

      const inputDate = new Date(value);
      if (isNaN(inputDate.getTime())) {
        return {invalidDate: true};
      }

      return inputDate <= maxDate ? null : {maxDate: {allowedDate: maxDateString}};
    };
  }

}
